import { alpha } from '@mui/material/styles'
import { palette } from 'c1ui'
import { moduleStyleType } from 'components/no-ui/styles/styleTypes'

export const styles: moduleStyleType = {
    container: {
        display: 'flex',
        justifyContent: 'flex-start',
        flexWrap: 'wrap',
        margin: 0,
        padding: 0,
        '& > *': {
            margin: 0,
            padding: 0,
        },
    },
    chip: {
        position: 'relative',
        '& .MuiChip-clickableColorPrimary:hover': {
            backgroundColor: alpha(palette.brand.main, 0.4),
        },
        '& .MuiChip-clickableColorPrimary:focus': {
            backgroundColor: alpha(palette.brand.main, 0.4),
        },
        '& .MuiChip-clickableColorPrimary': {
            backgroundColor: alpha(palette.brand.main, 0.2),
        },
    },
    moreChips: {
        background: 'none',
        border: 'none',
        textDecoration: 'none',
        alignSelf: 'center',
        '&:hover': {
            textDecoration: 'underline',
        },
        '&:active': {
            color: alpha(palette.brand.main, 1),
        },
    },
}
